angular.module('vastdesk')
.component('copyButton', {
  bindings: {
    copyTarget: '@',
    copyButtonClass: '@',
    copyButtonText: '@'
  },
  template: '<button class="btn {{$copyCtrl.copyButtonClass}}" type="button" ng-bind-html="$copyCtrl.copyButtonContent"></button>',
  controllerAs: '$copyCtrl',
  controller: ['$element', function($element) {

    var self = this;

    this.$onInit = function() {
      self.copyButtonClass = self.copyButtonClass || 'btn-ss-submit';
      self.copyButtonText = self.copyButtonText || 'Copy';
      self.copyButtonContent = '<i class="far fa-clipboard"></i>' + self.copyButtonText;
    };

    function textToCopy() {
      var $target = $(self.copyTarget);
      if ($target.is('input, textarea')) {
        return $target.val() || '';
      }
      return $target.text() || '';
    }

    function showCopySuccessPopover() {
      $element.popover({
        animation: true,
        placement: 'top',
        content: '<i class="fa fa-check-square text-success"></i>',
        sanitize: false,
        trigger: 'manual',
        html: true,
        delay: {
          hide: 100
        }
      }).popover('show');

      setTimeout(function () {
        $element.popover('hide');
      }, 500);
    }

    function copyWithExecCommand(text) {
      // 1. Create a temporary hidden textarea element
      var textArea = document.createElement("textarea");
      textArea.value = text;

      // 2. Position it off-screen and set styles to prevent scrolling or zooming
      textArea.style.position = "fixed";
      textArea.style.top = "0";
      textArea.style.left = "-9999px";
      textArea.style.width = "2em";
      textArea.style.height = "2em";
      textArea.style.padding = "0";
      textArea.style.border = "none";
      textArea.style.outline = "none";
      textArea.style.shadow = "none";
      textArea.style.background = "transparent";

      // 3. Append to body, select text, and execute copy
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      // For mobile iOS devices
      textArea.setSelectionRange(0, 999999);

      var successful = false;
      try {
        successful = document.execCommand('copy');
      } catch (err) {
        console.error('Fallback copy failed:', err);
      }

      // 4. Clean up temporary element
      document.body.removeChild(textArea);
      return successful;
    }

    $element.on('click', function() {
      if (!self.copyTarget || self.copyTarget === '') {
        return;
      }

      var text = textToCopy();
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        navigator.clipboard.writeText(text)
          .then(showCopySuccessPopover)
          .catch(function () {
            //fallback to execCommand if Clipboard API fails
            if (copyWithExecCommand(text)) {
              showCopySuccessPopover();
            }
          });
      } else if (copyWithExecCommand(text)) {
         //fallback to execCommand if clipboard is not supported
        showCopySuccessPopover();
      }
    });

  }]
});
